export default __webpack_public_path__ + "586aff6aef412265096985cd0e9ce8f9.png";